import { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Spacer from "../../../components/Spacer";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import RefusedRequestService from "../../../services/RefusedRequestService";
import Message from "../../tool-accepted/Message";
import { FormGroup, FormControlLabel, Checkbox , Typography, DialogContent, useStepContext, FormControl, FormLabel} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Alert from "@material-ui/lab/Alert";
import Loading from "../../../components/loading";
import AcceptRequestService from "../../../services/AcceptRequestService";
import AcceptedHelpService from "../../../services/AcceptedHelpService";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer,Paper } from '@mui/material'; 
import { headerData } from "../../../data/modules/my-validations-header";
import MainContainer from "../../../components/MainContainer";
import { Link } from "react-router-dom";
import ts from "typescript";
import { useParams } from 'react-router';



const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  btnAnnulerDialog: {
    background: "red",
    color: "white",
  },
  btnValiderDialog: {
    background: "rgb(19, 62, 103)",
    color: "white",
  },
  label: {
    fontWeight: "bold",
  },
  step1Title: {
    textAlign: "center",
  },
  step1Grid: {
    padding: "10px",
  },
  gridItem: {
    height: "25px",
    marginBottom: theme.spacing(8),
  },
}));

export default function ValidationMission() {
  const navigate = useNavigate();
  const classes = useStyles();
  const {id} = useParams();
  const file_validation_request_id = id;
  
  const [rows,setRows]=useState('');
  const [error, setError] = useState('');
  const [openValidateRequest, setOpenValidateRequest] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [errorMdpMessage, setErrorMdpMessage] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [opentdr,setOpentdr]=useState(false);
  const [detail,setDetail]=useState([]);
  const [selectuser,setSelectuser]=useState('');
  const [message, setMessage] = useState({
    openMessage: false,
    color: "green",
    messageInfo: "",
  });
  const { openMessage, color, messageInfo } = message;
  const [openrefusmission, setOpenrefusmission] = useState(false);
  const [openrefustdr, setOpenrefustdr] = useState(false);
  const [obsmission,setObsmission]=useState(false);
  const [obstdr,setObstdr]=useState(false);
  const [openrefusmissiontous, setOpenrefusmissiontous] = useState(false);
  const [openrefustdrtous, setOpenrefustdrtous] = useState(false);
  const [obsmissiontous,setObsmissiontous]=useState(false);
  const [obstdrtous,setObstdrtous]=useState(false);
  const [checked, setChecked] = useState({
    mission: {
      tousValider: false,
      tousModifier: false,
      tousValiderObservation:false,
      toutRefuser: false,
      observationplanning:'',
      observationrefus:''
    },
    tdr: {
      tousValider: false,
      tousModifier: false,
      tousValiderObservation:false,
      toutRefuser: false,
      observationtdr:[],
      observationrefus:''
    },
  });
  const [filter,setFilter]=useState(
    {
    mdp:''
    }
  );


   const handleChange = (event, type) => {
        const { name } = event.target;

       
        let diff = "";
        if (name === "tousValider") {
            diff = "valide";
        }
        else if (name === "tousValiderObservation") {
          diff = "valide";
          console.log("bbbbb");
          
          if (type==="mission") {
            console.log("ddddd");
            setObsmissiontous(true);
          } else {
            console.log("tttttt");
            setObstdrtous(true);
          }
        } 
       else if (name === "tousModifier") {
            diff = "modif";
        } else {
            diff = "refuse";
        }

        if (diff==="modif" && type==="mission") {
            setObsmissiontous(true);
        } 
        if (diff==="modif" && type==="tdr") {
            setObstdrtous(true);
        }
        if (diff==="refuse" && type==="mission") {
            setOpenrefusmissiontous(true);
        } 
        if (diff==="refuse" && type==="tdr") {
            setOpenrefustdrtous(true);
        }

        setChecked((prevState) => {
            const updatedState = { ...prevState };

            updatedState[type] = {
                tousValider: false,
                tousModifier: false,
                toutRefuser: false,
            };

            updatedState[type][name] = !prevState[type][name];

            return updatedState;
        });

        detail.forEach((ts) => {
            const userId = ts.user_id;
            ts.details.forEach((tr, indexs) => {
                if (tr.active === true) {
                    setSelectedValues((prevSelectedValues) => {
                        const existingIndex = prevSelectedValues.findIndex(
                            (item) => item.userId === userId && item.validationType === type
                        );
              
                        if (existingIndex !== -1) {
                            const updatedValues = [...prevSelectedValues];
                            updatedValues[existingIndex] = {
                                ...updatedValues[existingIndex],
                                value:diff,
                                observatiorefus: updatedValues[existingIndex].observatiorefus || '',
                                observationdetail: updatedValues[existingIndex].observationdetail || [],
                                observatioplanning :updatedValues[existingIndex].observatiorefus || ''
                            };
                            return updatedValues;
                        } else {
                            return [
                                ...prevSelectedValues,
                                { userId, value:diff, validationType:type, observatiorefus: '',observationdetail:[] ,observatioplanning :''},
                            ];
                        }
                    });
                }
            });
        });
    };



   const getObservationValue = (userId, validationType, fieldName) => {
    const userEntry = selectedValues.find(
      (item) => item.userId === userId && item.validationType === validationType
    );
  
    return userEntry?.observationdetail?.find((obs) => obs[fieldName])?.[fieldName] || "";
   };
  
   
   function handleobservationdetail(event, userId, validationType) {
    const { name, value } = event.target;
  
    setSelectedValues((prevSelectedValues) => {
      const existingIndex = prevSelectedValues.findIndex(
        (item) => item.userId === userId && item.validationType === validationType
      );
  
      if (existingIndex !== -1) {
        const updatedValues = [...prevSelectedValues];
        let observationDetails = updatedValues[existingIndex].observationdetail || [];
  
        const fieldIndex = observationDetails.findIndex((obs) => obs.hasOwnProperty(name));
  
        if (fieldIndex !== -1) {
          observationDetails[fieldIndex][name] = value;
        } else {
          observationDetails.push({ [name]: value });
        }
  
        updatedValues[existingIndex] = {
          ...updatedValues[existingIndex],
          observationdetail: observationDetails,
        };
  
        return updatedValues;
      } else {
        return [
          ...prevSelectedValues,
          {
            userId,
            validationType,
            observationdetail: [{ [name]: value }],
          },
        ];
      }
    });
  }
  
  

  const handleobservationrefus = (event, userId, validationType) => {
    const { name, value } = event.target;
  
    setSelectedValues((prevSelectedValues) => {
      const existingIndex = prevSelectedValues.findIndex(
        (item) => item.userId === userId && item.validationType === validationType
      );
  
      if (existingIndex !== -1) {
        const updatedValues = [...prevSelectedValues];
        updatedValues[existingIndex] = {
          ...updatedValues[existingIndex],
          [name]: value,
        };
        return updatedValues;
      } else {
        return prevSelectedValues;
      }
    });
   };
  
  

    const handleCheckboxChange = (userId, value, validationType) => { 
       setSelectuser(userId);
      
      if (value === "refuse" && validationType === "mission") {
          setOpenrefusmission(true);
      }
      if (value==="refuse" && validationType==="tdr") {
          setOpenrefustdr(true);
      }
      if (value==="modif" && validationType==="tdr") {
        setObstdr(true);
      }
      if (value==="modif" && validationType==="mission") {
        setObsmission(true);
      }

      setSelectedValues((prevSelectedValues) => {
          const existingIndex = prevSelectedValues.findIndex(
              (item) => item.userId === userId && item.validationType === validationType
          );

          if (existingIndex !== -1) {
              const updatedValues = [...prevSelectedValues];
              updatedValues[existingIndex] = {
                  ...updatedValues[existingIndex],
                  value,
                  observatiorefus: updatedValues[existingIndex].observatiorefus || '',
                  observationdetail: updatedValues[existingIndex].observationdetail || [],
                  observatioplanning :updatedValues[existingIndex].observatiorefus || ''
              };
              return updatedValues;
          } else {
              return [
                  ...prevSelectedValues,
                  { userId, value, validationType, observatiorefus: '',observationdetail:[] ,observatioplanning :''},
              ];
          }
      });

    
  };

   const handleCloseValidateRequest = (event, reason) => {
    setOpenValidateRequest(false);
   }

   const handleFocusPassword = (event, reason) => {
    setOpenValidateRequest(true);
   }
   
   function handleClickPassword() {
    if (filter.mdp.trim() == "") {
      setError(true);
      setErrorMdpMessage("Mot de passe requis!!");

    } else {
      setLoading(true);
       
        AcceptRequestService.verifyMdp(filter.mdp,2).then((result) => {
          if (result.status) {      
              RefusedRequestService.correctvalidationmission(selectedValues,rows.file_request_id).then((result) => {
                if (result.status) {
                  setMessage({
                    ...message,
                    openMessage: true,
                    color: "green",
                    messageInfo: result.message,
                  });
                  // setTimeout(function () { navigate("/me/validations"); }, 2000);
                  // navigate("/me/validations");
                  // // window.location.reload();
                } else {
                    setMessage({
                      ...message,
                      openMessage: true,
                      color: "red",
                      messageInfo: "Erreur , veuillez essayer à nouveau.",
                    });
                    setLoading(false);
                }
              }).catch((err) => {
                  setMessage({
                    ...message,
                    openMessage: true,
                    color: "red",
                    messageInfo: "Erreur , veuillez essayer à nouveau.",
                  });
              });
          } else {
            setError(true);
            setErrorMdpMessage(result.message);
            setLoading(false);
          }
        }).catch((err) => {
          setError(true);
          setErrorMdpMessage('Une erreur s\'est produite');
          setLoading(false);
          // navigate("/acceptedHelp");

        });
      }
   }  

   function handleChangemdp(event) {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });

  }

  const handleClosetdr = () => {
    setOpentdr(false);
  };


  function handleRefusedRequest(){
       setOpenValidateRequest(true);
  }

  function handleCloseRefusedRequest()
  {
      navigate('/me/validations');
  }
  
  useEffect(() => {
    AcceptedHelpService.getDeatilsId(file_validation_request_id).then((result) => {
      if (result && result.data) {
        setDetail(result.data[0].Missionaires);
        setRows(result.data[0]);
      }
    });
  }, []);

  const handleClickOpentdr = () => {
    setOpentdr(true);
  };

  function handleCloseMessage() {
    setMessage({ ...message, openMessage: false });
  }


  const handleChangemodiftdr = (event) => {
    const { name, value } = event.target;

    const validationType = "refuse";
    const observationKey = "observatiorefus";
  
    setChecked((prevState) => ({
        ...prevState,
        tdr: {
            ...prevState.tdr,
            [name]: value, 
        },
    }));

    const updatedValues = detail.flatMap((ts) => {
        const userId = ts.user_id;
        

        return ts.details
            .filter((tr) => tr.active === true) 
            .map(() => {
                return {
                    userId,
                    validationType,
                    observationKey,
                    value, 
                };
            });
    });

    setSelectedValues((prevSelectedValues) => {
        const updatedState = [...prevSelectedValues];

        updatedValues.forEach(({ userId, validationType, observationKey, value }) => {
            const existingIndex = updatedState.findIndex(
                (item) =>
                    item.userId === userId &&
                    item.validationType === "tdr" &&
                    item.value === validationType
            );

            if (existingIndex !== -1) {
                updatedState[existingIndex] = {
                    ...updatedState[existingIndex],
                    [observationKey]: value,
                };
            }
        });

        return updatedState;
    });
    
};

   const handlechangetoustdr = (event) => {
      const { name, value } = event.target;
      const validationType = "modif"; 
      const observationKey = "observationdetail"; 

      setSelectedValues((prevSelectedValues) => {
        const updatedValues = [...prevSelectedValues];

        detail.forEach((ts) => {
          const userId = ts.user_id;

          ts.details
            .filter((tr) => tr.active === true)
            .forEach(() => {
              const existingIndex = updatedValues.findIndex(
                (item) => item.userId === userId && item.validationType === validationType
              );

              if (existingIndex !== -1) {
                let observationDetails = updatedValues[existingIndex].observationdetail || [];

                const fieldIndex = observationDetails.findIndex((obs) => obs.hasOwnProperty(name));

                if (fieldIndex !== -1) {
                  observationDetails[fieldIndex][name] = value;
                } else {
                  observationDetails.push({ [name]: value });
                }

                updatedValues[existingIndex] = {
                  ...updatedValues[existingIndex],
                  observationdetail: observationDetails,
                };
              } else {
                // Ajouter une nouvelle entrée
                updatedValues.push({
                  userId,
                  validationType,
                  observationdetail: [{ [name]: value }],
                });
              }
            });
        });

        // Retourner le tableau mis à jour
        return updatedValues;
      });
    };

  const handleChangemodifmission = (event) => {
    const { name, value } = event.target;

    const validationType = name === "observationplanning" ? "modif" : "refuse";
    const observationKey = name === "observationplanning" ? "observatioplanning" : "observatiorefus";
  
    setChecked((prevState) => ({
        ...prevState,
        mission: {
            ...prevState.mission,
            [name]: value, 
        },
    }));

    const updatedValues = detail.flatMap((ts) => {
        const userId = ts.user_id;
        

        return ts.details
            .filter((tr) => tr.active === true) 
            .map(() => {
                return {
                    userId,
                    validationType,
                    observationKey,
                    value, 
                };
            });
    });

    setSelectedValues((prevSelectedValues) => {
        const updatedState = [...prevSelectedValues];

        updatedValues.forEach(({ userId, validationType, observationKey, value }) => {
            const existingIndex = updatedState.findIndex(
                (item) =>
                    item.userId === userId &&
                    item.validationType === "mission" &&
                    item.value === validationType
            );

            if (existingIndex !== -1) {
                updatedState[existingIndex] = {
                    ...updatedState[existingIndex],
                    [observationKey]: value,
                };
            }
        });

        return updatedState;
    });
    
};


  return (
    <MainContainer {...headerData}>
      <Message open={openMessage} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
       
        <div className={classes.root}>
        <h2 
            style={{ 
                textAlign: 'center', 
                color: '#003366', 
                textDecoration: 'underline', 
                padding: '0px',
                fontFamily: 'Roboto, sans-serif'  
            }}
        >
           Validation de la demande de mission
         </h2>
        <Grid className={classes.step1Grid} container spacing={2}>
        <Grid item xs={4}>
                  <label className={classes.label}>Nom et Prénom du demandeur:</label>
        </Grid>
        <Grid item xs={8}>
            <label className={classes.label1}>{rows['first_name']+' '+rows['last_name']}</label>
        </Grid>
         <Grid item xs={4}>
            <label className={classes.label}>Objet de la mission :</label>
         </Grid>
         <Grid item xs={8}>
            <label className={classes.label1}>{rows['mission_title']}</label>
          </Grid>
         
           {(rows['typeplanning'] ==="Moins")&& (
            <>
              <Grid item xs={4}>
                <label className={classes.label}>Date :</label>
              </Grid>
              <Grid item xs={8}>
                <label className={classes.label1}>{rows['date_depart']} au  {rows['date_retour']} </label>
              </Grid>
              <Grid item xs={4}>
                <label className={classes.label}>Lieu de destination:</label>
              </Grid>
              <Grid item xs={8}>
                <label className={classes.label1}>{rows['lieu']}</label>
              </Grid>
            </>
          )}
           {(rows['typeplanning'] ==="Plus") && (
             <>
                  <Grid item xs={12}>
                     <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Lieu/Direction</TableCell>
                            <TableCell align="center">Date</TableCell>
                            <TableCell align="center">Missionaires</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows['destination'].map((row) => (
                              <TableRow
                                key={row.planning_destination}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                              >
                                <TableCell component="th" scope="row">
                                  {row.lieu}/{row.direction}
                                </TableCell>
                                <TableCell align="center">{row.date_debut} au {row.date_fin}</TableCell>
                                <TableCell align="center">        
                                  {row.missionary.map((ts, index) => (
                                    <p key={index}>{ts.nom}</p>
                                  ))}
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    </Grid>
             </>
           )}
         
            <Grid item xs={4}>
                      </Grid>
                      <Grid item xs={8}>
                        <Button
                          className={classes.button}
                          onClick={handleClickOpentdr}
                        >
                        Consulter le résumé du TDR
                        </Button>
                        <Dialog
                          open={opentdr}
                          onClose={handleClosetdr}
                          fullWidth
                          maxWidth='sm'
                        >
                          <DialogTitle  id="form-dialog-title1">Résumé du TDR</DialogTitle>
                          <DialogContent>
                             <h3>Context et Justification</h3>
                             <p>{rows['context']}</p>
                            {Array.isArray(rows['objectif']) && rows['objectif'].length > 0 && (
                              <>
                                <h3>Objectifs</h3>
                                <ul>
                                  {rows['objectif'].map((ts, index) => (
                                    <li key={index}>{ts}</li>
                                  ))}
                                </ul>
                              </>
                            )}

                            {Array.isArray(rows['resultat']) && rows['resultat'].length > 0 && (
                              <>
                                <h3>Résultat attendu</h3>
                                <ul>
                                  {rows['resultat'].map((ts, index) => (
                                    <li key={index}>{ts}</li>
                                  ))}
                                </ul>
                              </>
                            )}

                            {Array.isArray(rows['tache']) && rows['tache'].length > 0 && (
                              <>
                                <h3>Tâche</h3>
                                <ul>
                                  {rows['tache'].map((ts, index) => (
                                    <li key={index}>{ts}</li>
                                  ))}
                                </ul>
                              </>
                            )}

                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleClosetdr} color="primary">
                              Fermer
                            </Button>
                          </DialogActions>
                        </Dialog>
                    </Grid>
                    <Grid item xs={4}>
                  </Grid>
                  <Grid item xs={8}>
                          La TDR sous forme{" "}
                          <Link to={"/uploads/Missions"+ "/" + rows.filename+".pdf"} target="_blank" > pdf. </Link>
                          <br></br>
           
                  </Grid>
                  <Grid item xs={4}>
                  </Grid>
                  <Grid item xs={8}>
                      Annexe : {!rows.annexe ? (
                          "Aucune annexe"
                      ) : (
                          <a  href={"/uploads/Annexe/" + rows.annexe} download target="_blank" >
                              Voir l'annexe
                          </a>
                      )}
                  </Grid>
                  <Grid item xs={4}>
                     <label className={classes.label1}>Mission</label>
                  </Grid>
                  <Grid item xs={8}>
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={checked.mission.tousValider}
                            onChange={(e) => handleChange(e, "mission")}
                            name="tousValider"
                        />
                        }
                        label="Tous valider"
                    />
                    {/* <FormControlLabel
                        control={
                        <Checkbox
                            checked={checked.mission.tousValiderObservation}
                            onChange={(e) => handleChange(e, "mission")}
                            name="tousValiderObservation"
                        />
                        }
                        label="Tous valider avec observation"
                    /> */}
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={checked.mission.tousModifier}
                            onChange={(e) => handleChange(e, "mission")}
                            name="tousModifier"
                        />
                        }
                        label="Tous modifier"
                    />
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={checked.mission.toutRefuser}
                            onChange={(e) => handleChange(e, "mission")}
                            name="toutRefuser"
                        />
                        }
                        label="Tout refuser"
                    />
                    {checked.mission.tousModifier &&
                        <Dialog
                        open={obsmissiontous}
                        onClose={() => setObsmissiontous(false)}
                        maxWidth="md"
                        fullWidth
                    >
                        <DialogTitle>Observation planning</DialogTitle>
                        <DialogContent dividers>
                            <TextField
                                fullWidth
                                label="Raison"
                                variant="outlined"
                                name="observationplanning"
                                multiline
                                minRows={3}
                                maxRows={5}
                                value={checked.mission.observationplanning} 
                                onChange={handleChangemodifmission} 
                                autoFocus
                                margin="dense"
                            />
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={() => setObsmissiontous(false)} color="primary">
                            Valider
                        </Button>
                        </DialogActions>
                    </Dialog>
                    }
                    {checked.mission.toutRefuser &&
                        <Dialog
                        open={openrefusmissiontous}
                        onClose={() => setOpenrefusmissiontous(false)}
                        maxWidth="md"
                        fullWidth
                    >
                        <DialogTitle>Raison</DialogTitle>
                        <DialogContent dividers>
                            <TextField
                                fullWidth
                                label="Raison"
                                variant="outlined"
                                name="observatiorefus"
                                multiline
                                minRows={3}
                                maxRows={5}
                                value={checked.mission.observationrefus} 
                                onChange={handleChangemodifmission} 
                                autoFocus
                                margin="dense"
                            />
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={() => setOpenrefusmissiontous(false)} color="primary">
                            Valider
                        </Button>
                        </DialogActions>
                    </Dialog>
                    }
                    </Grid>

                    <Grid item xs={4}>
                    <label className={classes.label1}>TDR</label>
                    </Grid>
                    <Grid item xs={8}>
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={checked.tdr.tousValider}
                            onChange={(e) => handleChange(e, "tdr")}
                            name="tousValider"
                        />
                        }
                        label="Tous valider"
                    />
                     {/* <FormControlLabel
                        control={
                        <Checkbox
                            checked={checked.tdr.tousValiderObservation}
                            onChange={(e) => handleChange(e, "tdr")}
                            name="tousValiderObservation"
                        />
                        }
                        label="Tous valider avec observation"
                    /> */}
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={checked.tdr.tousModifier}
                            onChange={(e) => handleChange(e, "tdr")}
                            name="tousModifier"
                        />
                        }
                        label="Tous modifier"
                    />
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={checked.tdr.toutRefuser}
                            onChange={(e) => handleChange(e, "tdr")}
                            name="toutRefuser"
                        />
                        }
                        label="Tout refuser"
                    />
                    {checked.tdr.tousModifier &&
                        <Dialog
                        open={obstdrtous}
                        onClose={() => setObstdrtous(false)}
                        maxWidth="md"
                        fullWidth
                    >
                        <DialogTitle>Observation</DialogTitle>
                              <DialogContent dividers sx={{ pb: 2 }}>
                                 <TextField
                                    fullWidth
                                    rows={3}
                                    multiline
                                    id="outlined-basic"
                                    size="small"
                                    label="Contexte et justification"
                                    variant="outlined"
                                    name="context"
                                    //value={getObservationValue(selectuser, "tdr", "context")}
                                    onChange={handlechangetoustdr}
                                    margin="normal"
                                    />
                                    <TextField
                                        fullWidth
                                        rows={3}
                                        multiline
                                        id="outlined-basic"
                                        size="small"
                                        label="Objectifs"
                                        variant="outlined"
                                        name="objectif"
                                        //value={getObservationValue(selectuser, "tdr", "objectif")}
                                        onChange={handlechangetoustdr}
                                        margin="normal"
                                    />
                                    <TextField
                                        fullWidth
                                        rows={3}
                                        multiline
                                        id="outlined-basic"
                                        size="small"
                                        label="Résultat attendu"
                                        variant="outlined"
                                        name="result"
                                       // value={getObservationValue(selectuser, "tdr", "result")}
                                        onChange={handlechangetoustdr}
                                        margin="normal"
                                    />
                                    <TextField
                                        fullWidth
                                        rows={3}
                                        multiline
                                        id="outlined-basic"
                                        size="small"
                                        label="Agenda"
                                        variant="outlined"
                                        name="agenda"
                                        //value={getObservationValue(selectuser, "tdr", "agenda")}
                                        onChange={handlechangetoustdr}
                                        margin="normal"
                                    />
                                    </DialogContent>
                        <DialogActions>
                        <Button onClick={() => setObstdrtous(false)} color="primary">
                            Valider
                        </Button>
                        </DialogActions>
                    </Dialog>
                    }
                    {checked.tdr.toutRefuser &&
                        <Dialog
                        open={openrefustdrtous}
                        onClose={() => setOpenrefustdrtous(false)}
                        maxWidth="md"
                        fullWidth
                    >
                        <DialogTitle>Raison</DialogTitle>
                        <DialogContent dividers>
                            <TextField
                                fullWidth
                                label="Raison"
                                variant="outlined"
                                name="observatiorefus"
                                multiline
                                minRows={3}
                                maxRows={5}
                                value={checked.tdr.observationrefus} 
                                onChange={handleChangemodiftdr} 
                                autoFocus
                                margin="dense"
                            />
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={() => setOpenrefustdrtous(false)} color="primary">
                            Valider
                        </Button>
                        </DialogActions>
                    </Dialog>
                    }
                    </Grid>
        </Grid>

        <Grid className={classes.step1Grid} container>
            <div style={{ maxHeight: '400px', overflowY: 'auto', width: '100%' }}>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell style={{ maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}>Missionaires</TableCell>
                    <TableCell style={{ maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}>Validateur</TableCell>
                    <TableCell style={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis' }}>Action Mission</TableCell>
                    <TableCell style={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis' }}>Action TDR</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {detail.map((ts, index) => (
                    <TableRow key={index}>
                        <TableCell>
                        <Typography variant="body1">{ts.Nom}</Typography>
                        </TableCell>
                        <TableCell>
                        {Array.isArray(ts.details) &&
                            ts.details.map((td, indexs) => (
                            <div key={indexs}>
                                <h5>
                                {td.name} ({td.status})
                                </h5>
                                {indexs < ts.details.length - 1 && <span> ----&gt;</span>}
                            </div>
                            ))}
                        </TableCell>
                        <TableCell>
                        {Array.isArray(ts.details) &&
                            ts.details.map((td, indexs) => (
                            <div key={indexs}>
                                {td.active === true && (
                                <FormGroup>
                                    <FormControlLabel
                                    checked={selectedValues.some(
                                        (item) =>
                                        item.userId === td.user_id && item.value === 'valide' && item.validationType === "mission"
                                    )}
                                    control={
                                        <Checkbox
                                        onChange={() =>
                                            handleCheckboxChange(
                                            td.user_id,
                                            'valide',
                                            'mission'
                                            )
                                        }
                                        />
                                    }
                                    label="Valider"
                                    />
                                    <FormControlLabel
                                    checked={selectedValues.some(
                                        (item) =>
                                        item.userId === td.user_id && item.value === 'modif' && item.validationType === "mission"
                                    )}
                                    control={
                                        <Checkbox
                                        onChange={() =>
                                            handleCheckboxChange(
                                            td.user_id,
                                            'modif',
                                            'mission'
                                            )
                                        }
                                        />
                                    }
                                    label="A modifier"
                                    />
                                    <FormControlLabel
                                    checked={selectedValues.some(
                                        (item) =>
                                        item.userId === td.user_id && item.value === 'refuse' && item.validationType === "mission"
                                    )}
                                    control={
                                        <Checkbox
                                        onChange={() =>
                                            handleCheckboxChange(
                                            td.user_id,
                                            'refuse',
                                            'mission'
                                            )
                                        }
                                        />
                                    }
                                    label="Réfuser"
                                    />
                                </FormGroup>
                                )}
                                {td.active === false && (
                                <FormGroup>
                                    <FormControlLabel
                                    checked={selectedValues.some(
                                        (item) =>
                                        item.userId === td.user_id && item.value === 'refuse' && item.validationType === "mission"
                                    )}
                                    control={
                                        <Checkbox
                                        onChange={() =>
                                            handleCheckboxChange(
                                            td.user_id,
                                            'refuse',
                                            'mission'
                                            )
                                        }
                                        />
                                    }
                                    label="Refuser"
                                    />
                                </FormGroup>
                                )}
                                {td.active === 'autre' && <></>}
                                {selectedValues.some(
                                (item) =>
                                    item.userId === selectuser &&
                                    item.value === "refuse" &&
                                    item.validationType === "mission"
                                ) && (
                                <Dialog
                                    open={openrefusmission}
                                    onClose={() => setOpenrefusmission(false)}
                                    maxWidth="md"
                                    fullWidth
                                >
                                    <DialogTitle>Motif du refus</DialogTitle>
                                    <DialogContent dividers>
                                    <TextField
                                        fullWidth
                                        label="Raison"
                                        variant="outlined"
                                        name="observatiorefus"
                                        multiline
                                        minRows={3}
                                        maxRows={5}
                                        value={
                                        selectedValues.find(
                                            (item) =>
                                            item.userId === selectuser && item.value === "refuse" && item.validationType === "mission"
                                        )?.observatiorefus || ""
                                        }
                                        onChange={(e) => handleobservationrefus(e, selectuser, "mission")}
                                        autoFocus
                                        margin="dense"
                                    />
                                    </DialogContent>
                                    <DialogActions>
                                    <Button onClick={() => setOpenrefusmission(false)} color="primary">
                                        Valider
                                    </Button>
                                    </DialogActions>
                                </Dialog>
                                )}
                                {selectedValues.some(
                                (item) =>
                                    item.userId === selectuser &&
                                    item.value === 'modif' 
                                    && item.validationType === "mission"
                                ) && (
                                <Dialog
                                    open={obsmission}
                                    onClose={() => setObsmission(false)}
                                    maxWidth="md"
                                    fullWidth
                                >
                                    <DialogTitle>Observation planning</DialogTitle>
                                    <DialogContent dividers>
                                    <TextField
                                        fullWidth
                                        label="Raison"
                                        variant="outlined"
                                        name="observatioplanning"
                                        multiline
                                        minRows={3}
                                        maxRows={5}
                                        value={selectedValues.find(item => item.userId === selectuser && item.value === 'modif' && item.validationType === "mission")?.observatioplanning || ''}
                                        onChange={(e) => handleobservationrefus(e, selectuser, "mission")}
                                        autoFocus
                                        margin="dense"
                                    />
                                    </DialogContent>
                                    <DialogActions>
                                    <Button onClick={() => setObsmission(false)} color="primary">
                                        Valider
                                    </Button>
                                    </DialogActions>
                                </Dialog>
                                )}
                            </div>
                            ))}
                        </TableCell>
                        <TableCell>
                        {Array.isArray(ts.details) &&
                            ts.details.map((td, indexs) => (
                            <div key={indexs}>
                                {td.active === true && (
                                <FormGroup>
                                    <FormControlLabel
                                    checked={selectedValues.some(
                                        (item) =>
                                        item.userId === td.user_id && item.value === 'valide' && item.validationType === "tdr"
                                    )}
                                    control={
                                        <Checkbox
                                        onChange={() =>
                                            handleCheckboxChange(
                                            td.user_id,
                                            'valide',
                                            'tdr'
                                            )
                                        }
                                        />
                                    }
                                    label="Valider"
                                    />
                                    <FormControlLabel
                                    checked={selectedValues.some(
                                        (item) =>
                                        item.userId === td.user_id && item.value === 'modif' && item.validationType === "tdr"
                                    )}
                                    control={
                                        <Checkbox
                                        onChange={() =>
                                            handleCheckboxChange(
                                            td.user_id,
                                            'modif',
                                            'tdr'
                                            )
                                        }
                                        />
                                    }
                                    label="A modifier"
                                    />
                                    <FormControlLabel
                                    checked={selectedValues.some(
                                        (item) =>
                                        item.userId === td.user_id && item.value === 'refuse' && item.validationType === "tdr"
                                    )}
                                    control={
                                        <Checkbox
                                        onChange={() =>
                                            handleCheckboxChange(
                                            td.user_id,
                                            'refuse',
                                            'tdr'
                                            )
                                        }
                                        />
                                    }
                                    label="Réfuser"
                                    />
                                </FormGroup>
                                )}
                                {td.active === false && (
                                <FormGroup>
                                    <FormControlLabel
                                    checked={selectedValues.some(
                                        (item) =>
                                        item.userId === td.user_id && item.value === 'refuse' && item.validationType === "tdr"
                                    )}
                                    control={
                                        <Checkbox
                                        onChange={() =>
                                            handleCheckboxChange(
                                            td.user_id,
                                            'refuse',
                                            'tdr'
                                            )
                                        }
                                        />
                                    }
                                    label="Refuser"
                                    />
                                </FormGroup>
                                )}
                                {td.active === 'autre' && <></>}
                                {selectedValues.some(
                                (item) =>
                                    item.userId === selectuser && item.value === 'refuse' && item.validationType === "tdr"
                                ) && (
                                <Dialog
                                    open={openrefustdr}
                                    onClose={() => setOpenrefustdr(false)}
                                    maxWidth="md"
                                    fullWidth
                                >
                                    <DialogTitle>Motif du refus</DialogTitle>
                                    <DialogContent dividers>
                                    <TextField
                                        fullWidth
                                        label="Raison"
                                        variant="outlined"
                                        name="observatiorefus"
                                        multiline
                                        minRows={3}
                                        maxRows={5}
                                        value={selectedValues.find(item => item.userId === selectuser && item.validationType === "tdr")?.observatiorefus || ''}
                                        onChange={(e) => handleobservationrefus(e, selectuser, "tdr")}
                                        autoFocus
                                        margin="dense"
                                    />
                                    </DialogContent>
                                    <DialogActions>
                                    <Button onClick={() => setOpenrefustdr(false)} color="primary">
                                        Valider
                                    </Button>
                                    </DialogActions>
                                </Dialog>
                                )}
                                {selectedValues.some(
                                (item) =>
                                    item.userId === selectuser && item.value === 'modif' && item.validationType === "tdr"
                                ) && (
                                <Dialog
                                    open={obstdr}
                                    onClose={() => setObstdr(false)}
                                    maxWidth="md"
                                    fullWidth
                                >
                                    <DialogTitle>Observation</DialogTitle>
                                    <DialogContent dividers sx={{ pb: 2 }}>
                                    <TextField
                                        fullWidth
                                        rows={3}
                                        multiline
                                        id="outlined-basic"
                                        size="small"
                                        label="Contexte et justification"
                                        variant="outlined"
                                        name="context"
                                        value={getObservationValue(selectuser, "tdr", "context")}
                                        onChange={(e) => handleobservationdetail(e, selectuser, "tdr")}
                                        margin="normal"
                                    />
                                    <TextField
                                        fullWidth
                                        rows={3}
                                        multiline
                                        id="outlined-basic"
                                        size="small"
                                        label="Objectifs"
                                        variant="outlined"
                                        name="objectif"
                                        value={getObservationValue(selectuser, "tdr", "objectif")}
                                        onChange={(e) => handleobservationdetail(e, selectuser, "tdr")}
                                        margin="normal"
                                    />
                                    <TextField
                                        fullWidth
                                        rows={3}
                                        multiline
                                        id="outlined-basic"
                                        size="small"
                                        label="Résultat attendu"
                                        variant="outlined"
                                        name="result"
                                        value={getObservationValue(selectuser, "tdr", "result")}
                                        onChange={(e) => handleobservationdetail(e, selectuser, "tdr")}
                                        margin="normal"
                                    />
                                    <TextField
                                        fullWidth
                                        rows={3}
                                        multiline
                                        id="outlined-basic"
                                        size="small"
                                        label="Agenda"
                                        variant="outlined"
                                        name="agenda"
                                        value={getObservationValue(selectuser, "tdr", "agenda")}
                                        onChange={(e) => handleobservationdetail(e, selectuser, "tdr")}
                                        margin="normal"
                                    />
                                    </DialogContent>
                                    <DialogActions>
                                    <Button onClick={() => setObstdr(false)} color="primary">
                                        Valider
                                    </Button>
                                    </DialogActions>
                                </Dialog>
                                )}
                            </div>
                            ))}
                        </TableCell>
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
                </div>
              <Grid item xs={12}>
                <Spacer y={2} />
                <DialogActions>
                  <Button style={{ backgroundColor: "##f50057", color: "#FFFFFF" }} onClick={handleCloseRefusedRequest} color="secondary" variant="contained" >
                    Annuler
                  </Button>
                  <Button style={{ backgroundColor: "rgb(19, 62, 103)", color: "#FFFFFF",}} onClick={handleRefusedRequest} color="secondary" variant="contained" >
                    Confirmer
                  </Button>
                </DialogActions>
              </Grid>
            </Grid>
        </div>
      <div>
      <Dialog open={openValidateRequest} onClose={handleCloseValidateRequest} aria-labelledby="form-dialog-title1" fullWidth maxWidth="sm">
          <DialogTitle id="form-dialog-title1">
              Confirmation de la validation
          </DialogTitle>
          <br />
          <div className={classes.root}>
            <div>
              <h3 className={classes.step1Title}>Votre mot de passe </h3>
            </div>
            <Grid className={classes.step1Grid} container>
              <Grid className={classes.gridItem} item xs={12}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  size="small"
                  label="Votre mot de passe"
                  variant="outlined"
                  value={filter.mdp}
                  name="mdp"
                  type="password"
                  onChange={handleChangemdp}
                  onFocus={handleFocusPassword}
                  inputProps={{ maxLength: 50 }}
                />
              </Grid>
              <Grid item xs={12}>

                <Spacer y={3} />
             
                {isLoading && <Loading />}
                {error && (
                  <Alert severity="error">{errorMdpMessage}</Alert>
                )}
              </Grid>
              <Grid item xs={12}>
                <Spacer y={2} />
                <DialogActions>
                  <Button style={{ backgroundColor: "##f50057", color: "#FFFFFF" }} onClick={handleCloseValidateRequest} color="secondary" variant="contained" >
                    Annuler
                  </Button>
                  <Button style={{ backgroundColor: "rgb(19, 62, 103)", color: "#FFFFFF", }} onClick={handleClickPassword} color="secondary" variant="contained" >
                    Valider
                  </Button>
                </DialogActions>
              </Grid>
            </Grid>
          </div>
        </Dialog>
      </div>
    </MainContainer>
  );
}
